import React, { FC, useEffect } from 'react';

declare global {
  interface Window {
    _grnhse?: {
      load: () => void;
    };
  }
}

const Greenhouse: FC = () => {
  useEffect(() => {
    // Fetch the scriptUrl from the DOM
    const configElement = document.getElementById('greenhouse-config') as HTMLElement | null;
    const scriptUrl = configElement?.dataset.scriptUrl;

    if (!scriptUrl) {
      console.error('Greenhouse script URL not found in theme settings.');
      return;
    }

    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`) as HTMLScriptElement | null;

    if (window._grnhse) {
      // If the script is already loaded, just call the load function
      window._grnhse.load();
    } else if (existingScript) {
      // If the script tag exists but _grnhse is not yet available, wait for it to load
      existingScript.addEventListener('load', () => {
        window._grnhse?.load();
      });
    } else {
      // Create and append the script tag
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;

      script.onload = () => {
        window._grnhse?.load();
      };

      script.onerror = (event) => {
        console.error('Failed to load Greenhouse script', event);
      };

      document.body.appendChild(script);
    }
  }, []);

  return (
      <div id="grnhse_app"></div>
  );
};

export default Greenhouse;
